/** Factored out of library to avoid circular references */

import { logger } from '@tunasong/models'
import { NoteLib } from '../note/index.js'
import { isChordNotes, isChordVariant } from './chord-types.js'
import type { Chord } from './chord-types.js'

export const getName = (chord?: Chord, transposeSemiTones = 0) => {
  if (!chord) {
    return '-'
  }
  const isTransposed = transposeSemiTones > 0 || transposeSemiTones < 0
  const transposeSign = transposeSemiTones > 0 ? '+' : ''
  const transposeLabel = isTransposed ? ` (${transposeSign}${transposeSemiTones})` : ''

  if (isChordVariant(chord)) {
    const root = NoteLib.transpose(chord.root, transposeSemiTones)
    const variant = chord.variant ? chord.variant : ''
    const bassNote = chord.bassNote ? `/${NoteLib.transpose(chord.bassNote, transposeSemiTones)}` : ''

    return `${root}${variant}${bassNote}${transposeLabel}`
  } if (isChordNotes(chord)) {
    return `${chord.name}${transposeLabel}`
  } 
    logger.error(`Unknown chord shape - cannot transpose`, chord)
    return '- UNKNOWN -'
  
}
